import { ConnectionService } from 'ng-connection-service';
/* eslint-disable @typescript-eslint/naming-convention */
import data from '../assets/client/client.json';
import { Component, HostListener, Inject, NgZone, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import {
  NavigationEnd,
  NavigationStart,
  Router,
  ActivatedRoute,
} from '@angular/router';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { Platform, ToastController, NavController } from '@ionic/angular';
import { AutocloseOverlaysService } from './services/shared/autoclose-overlays.service';
import { UiService } from './services/ui.service';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter, finalize, map, pairwise } from 'rxjs/operators';
import { BarcodeScannerService } from './services/hardware-service/barcode-scanner/barcode-scanner.service';
import { PushNotificationService } from './services/push-notification/push-notification.service';
import { ApiErrorService } from './services/api-error.service';
import { Stripe } from '@capacitor-community/stripe';
import { environment } from 'src/environments/environment';
import { AccountService } from './services/user/account.service';
import { I18ConfigService } from './services/shared/I18-config.service';
import { TranslateService } from '@ngx-translate/core';
import { ThemeService } from './services/client/theme/theme.service';
import { ClientService } from './services/client/client/client.service';
import { LocalStorageService } from './services/localStorage/localStorage.service';
import { localStorageKeys } from './services/localStorage/localStorageVariables';
import * as Sentry from '@sentry/angular';
import { AnalyticsService } from './services/analytics/analytics.service';
import { Capacitor } from '@capacitor/core';
import { register } from 'swiper/element/bundle';
import { AppUpdateService } from './services/app-update/app-update.service';
import { Geolocation } from '@capacitor/geolocation';
import { LocationService } from './services/location/location.service';
import { captureTravelverseSsoFromUrl } from './services/shared/travelverse-sso.util';
import { AffiliateContextService } from './services/shared/affiliate-context.service';
import { TracingService } from './services/tracing.service';
import { ConsoleOverrideService } from './services/console-override.service';

// eslint-disable-next-line @typescript-eslint/ban-types
declare let gtag: Function;

register();
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  status = 'ONLINE';
  connected = true;
  hasError = false;
  isInitialLoading = true;
  internetToast: HTMLIonToastElement;
  isMobile: boolean;
  isMenuOpen = false;
  menuIcon = 'WEB_MENU_OPEN';
  selectedPartner: string;
  selectedPartnerLogo: string;
  partner: any;
  language: string;
  token: any;
  clientCode: any = '';
  hash: any;
  userType: any;
  loadPage: boolean;
  notificationSettingsSubscription: any;
  isdropDownDisabled: string;
  affiliateLanded = false;
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private autocloseOverlaysService: AutocloseOverlaysService,
    private router: Router,
    private route: ActivatedRoute,
    private platform: Platform,
    private uiService: UiService,
    private swUpdates: SwUpdate,
    private connectionService: ConnectionService,
    private toastController: ToastController,
    private barcodeScannerService: BarcodeScannerService,
    private pushNotificationService: PushNotificationService,
    private apiErrorService: ApiErrorService,
    private accountService: AccountService,
    private navController: NavController,
    private i18Config: I18ConfigService,
    private translate: TranslateService,
    private theme: ThemeService,
    private clientService: ClientService,
    private localStorageData: LocalStorageService,
    private analyticsService: AnalyticsService,
    private localStorageService: LocalStorageService,
    private locationService: LocationService,
    private appUpdateService: AppUpdateService,
    private affiliateContext: AffiliateContextService,
    private zone: NgZone,
    private tracing: TracingService,
    private _consoleOverride: ConsoleOverrideService
  ) {}

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    const platform = Capacitor.getPlatform();
    const width = window.innerWidth;
    this.isMobile =
      (platform !== 'web' && width <= 1199) ||
      (platform === 'web' && width < 520);
  }

  async ngOnInit(): Promise<void> {
    // Check if avpt is null or empty and remove guestTk from localStorage
    const avpt = this.localStorageService.getItem('avpt');
    if (!avpt || avpt.trim() === '') {
      this.localStorageService.removeItem(localStorageKeys.GUEST_TOKEN);
    }
    const urlParams = new URLSearchParams(window.location.search);
    this.affiliateLanded = captureTravelverseSsoFromUrl(this.localStorageService);
    this.handleJspJourney(urlParams);
    this.token = urlParams.get('token');
    this.clientCode = urlParams.get('client') || localStorage.getItem('client') || '';
    this.userType = urlParams.get('user_type') || 'non-prime';

    if (this.userType && this.userType.toLowerCase() !== 'prime') {
      this.userType = 'non-prime';
    } else if (this.userType && this.userType.toLowerCase() === 'prime') {
      this.userType = 'prime';
    }

    // Remove only the 'user_type' query param from the URL without reloading the page
    if (window.history.replaceState) {
      const url = new URL(window.location.href);
      url.searchParams.delete('user_type');
      window.history.replaceState(
        {},
        document.title,
        url.pathname + url.search
      );
    }
    if (this.userType) {
      const shouldSetUserType =
        ((this.accountService.isLoggedIn() ||
          this.localStorageService.getItem(localStorageKeys.GUEST_TOKEN)) &&
          urlParams.get('user_type')) ||
        (!this.accountService.isLoggedIn() &&
          !this.localStorageService.getItem(localStorageKeys.GUEST_TOKEN)) ||
        !this.accountService.userType;

      if (shouldSetUserType) {
        this.localStorageService.setItem(
          localStorageKeys.USER_TYPE,
          'bfl-' + this.userType.toLowerCase()
        );
      }
    }
    const platform = Capacitor.getPlatform();

    const width = window.innerWidth;
    this.isMobile =
      (platform !== 'web' && width <= 1199) ||
      (platform === 'web' && width < 520);
    this.language = this.localStorageData.getItem(localStorageKeys.LANGUAGE);
    this.theme.setClientData = data; // Assuming 'data' is defined elsewhere
    this.setPartnerEnvironment();

    if (
      (urlParams.get('user_type') || !this.accountService.userType) &&
      this.theme.getAppPid === 'bfl' && this.accountService.isLoggedIn()
    ) {
      const currentUserType = this.localStorageService.getItem(
        localStorageKeys.USER_TYPE
      );
      this.accountService.userType = currentUserType;
      const hash = this.localStorageService.getItem('loginhash');
      await this.changeUserType(currentUserType, hash);
    }

    const initialLoader = await this.uiService.presentGlobalLoading(
      'Loading...'
    );
    // Run initialization without blocking first paint; dismiss loader unless on /redirecting
    this.loadAsyncConfigurations()
      .catch(() => {})
      .finally(async () => {
        if (initialLoader) {
          await this.uiService.dismissGlobalLoading();
        }
        this.isInitialLoading = false;
      });
    if (Capacitor.getPlatform() !== 'web') {
      this.appUpdateService.handleAppUpdate();
    }
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?libraries=places&language=en&key=${environment.googlePlacesApiKey}`;
    script.async = true;
    script.onload = () => {
      // Code to access the DOM element and render the widget
    };
    document.head.appendChild(script);
  }

  private handleJspJourney(urlParams: URLSearchParams) {
    const journeyType = urlParams.get('journeyType');
    if (!journeyType || journeyType.toUpperCase() !== 'JSP') {
      return;
    }
    const voucherCode = urlParams.get('voucherCode');
    this.localStorageService.setItem(localStorageKeys.JOURNEY_TYPE, 'JSP');
    if (voucherCode) {
      this.localStorageService.setItem(
        localStorageKeys.VOUCHER_CODE,
        voucherCode
      );
    }
    this.router.navigateByUrl('/login');
  }

  async loadAsyncConfigurations() {
    if (this.token) {
      try {
        const response = await this.accountService
          .checkSoftLogin(this.token)
          .toPromise();
        if (response?.token) {
          // Decide where to store the data securely
          // TODO refactor below code to a centralized method which should manage proper signing in
          this.accountService.setUserInfo({
            name: response?.user_info?.name,
            email: response?.user_info?.email,
            profileImg: response?.user_info?.profileImg,
            userId: response?.user_info?.user_id ?? response?.user_info?.id,
          });
          // TODO there should be a separate object for active memebership
          this.accountService.token = response.token;
          this.accountService.registered = response.salted_userId;
          if(response?.user_info?.pno){
            this.localStorageService.setItem(localStorageKeys.PHONE_NUMBER, response.user_info.pno);
          }
          if(response?.tierInfo?.currency) {
            this.i18Config.setCurrency(response.tierInfo.currency);
          }else{
            this.i18Config.setCurrency(this.theme.getDefaultCurrency);
          }
          const defaultSSOUrl = this.localStorageData.getItem(localStorageKeys.DEFAULT_SSO_URL);
          if(defaultSSOUrl){
            this.navController.navigateRoot(
              defaultSSOUrl || 'membership/hotel_book',
            );
          }else{
            this.router.navigateByUrl(
              this.theme.defaultRoute || 'membership/hotel_book',
            );
          }
        } else {
          this.router.navigateByUrl('/error');
        }
      } catch (error) {
        this.router.navigateByUrl('/error');
      }
    } else if (this.theme.hasGuestLoginEnabled) {
      if (!this.accountService.isLoggedIn()) {
        //create a hash
        this.hash =
          this.localStorageService.getItem('loginhash') ||
          btoa(this.clientCode + Date.now());
        this.localStorageService.setItem('loginhash', this.hash);
        if (!this.localStorageService.getItem(localStorageKeys.GUEST_TOKEN)) {
          this.userType =
            this.localStorageService.getItem(localStorageKeys.USER_TYPE) ||
            'non-prime';
          try {
            const response = await this.accountService
              .checkGuestLogin(this.hash, this.userType, this.clientCode)
              .toPromise();
            if (response?.token) {
              // Decide where to store the data securely
              // TODO there should be a separate object for active memebership
              this.analyticsService.trackGuestLogin(response.salted_userId, {
                user_type: this.userType,
              });
              this.accountService.token = response.token;
              this.accountService.registered = response.salted_userId;
              if (response?.user_info) {
                this.accountService.setUserInfo({
                  ...response.user_info,
                  userId:response?.user_info?.user_id,
                  tier: response.user_info.tier?.trim() || '',
                });
              }
              if (response?.tierInfo?.currency) {
                this.i18Config.setCurrency(response.tierInfo.currency);
              } else {
                this.i18Config.setCurrency(this.theme.getDefaultCurrency);
              }
              this.router.navigateByUrl(this.theme.defaultRoute);
            } else {
              this.analyticsService.trackGuestLoginFailure(
                (response && JSON.stringify(response)) || 'Guest Login Failed',
                this.userType
              );
              this.router.navigateByUrl('/error');
            }
          } catch (error) {
            this.router.navigateByUrl('/error');
          }
        }
      }
    }
    // const clientData = await this.clientService.loadClientData().toPromise();
    // if (clientData?.partnerList) {
    //   this.theme.setClientData = clientData;
    //   this.setPartnerEnvironment();
    // }
  }

  async setPartnerEnvironment() {
    try {
      await this.theme.setTheme();
      this.analyticsService.init();
      // Apply affiliate landing side effects (locale, currency, analytics event, beacon)
      // only after theme + analytics are ready. Idempotent per landing.
      if (this.affiliateLanded) {
        this.affiliateContext.processLanding();
      }
    } catch (error) {
      console.error('Error during partner environment setup:', error);
      // Handle any errors that may occur during client data loading
    }
    const partnerPid = this.theme.getAppPid;
    Stripe.initialize({
      publishableKey:
        environment.stripePublishableKeys[partnerPid] ??
        environment.stripePublishableKeys.smt,
    });
    this.initializeApp();
    this.setInitialPage();
  }

  async changeUserType(currentUserType, hash) {
    try {
      const response = await this.accountService
        .changeUserType(
          currentUserType,
          this.localStorageService.getItem(localStorageKeys.PHONE_NUMBER),
          hash
        )
        .toPromise();
      if (response?.token) {
        this.analyticsService.trackUnified('change_user_type', {
          legacy_event_name: 'Change UserType',
          current_user_type: currentUserType,
          phone_number: this.localStorageService.getItem(
            localStorageKeys.PHONE_NUMBER
          ),
          hash: hash,
          message: response?.message,
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  setInitialPage() {
    this.loadPage = true;
    this.isdropDownDisabled = this.localStorageData.getCookie(
      localStorageKeys.IS_DD_DISABLED
    );
    this.selectedPartner = this.theme.getClientName;
    this.partner = this.theme.getPartnerByDomain();
    this.selectedPartnerLogo = this.theme.getAppLogo?.whiteLogo;

    if (
      this.theme.getClientName === 'thomascook_fc' ||
      this.theme.getClientName === 'thomascook_lt'
    ) {
      this.isdropDownDisabled = 'true';
    }

    const faviconLink = document.createElement('link');
    faviconLink.rel = 'icon';
    faviconLink.href = this.theme.getAppFavicon;
    faviconLink.type = 'image/png';
    faviconLink.id = 'favicon';
    const existingFavicon = document.getElementById('favicon');
    if (existingFavicon) {
      document.head.removeChild(existingFavicon);
    }
    document.head.appendChild(faviconLink);

    const faviconTitle = document.createElement('title');
    faviconTitle.text = this.theme.getAppName; // Add your desired text here
    faviconTitle.id = 'title';
    const existingFaviconTitle = document.getElementById('title');
    if (existingFaviconTitle) {
      document.head.removeChild(existingFaviconTitle);
    }
    document.head.appendChild(faviconTitle);
  }

  openMenu() {
    this.isMenuOpen = !this.isMenuOpen;
    this.menuIcon = this.isMenuOpen ? 'WEB_MENU_CLOSE' : 'WEB_MENU_OPEN';
  }
  closeMenu() {
    this.isMenuOpen = false;
    this.menuIcon = 'WEB_MENU_OPEN';
  }

  selectClient(e) {
    this.accountService.logout();
    if (e.target.selectedIndex !== 0) {
      this.theme.setClientByParameter(e.target.value);
      this.localStorageData.setCookies(
        localStorageKeys.IS_DD_DISABLED,
        'false',
        1
      );
      this.selectedPartner = this.theme.getClientName;
      window.location.replace(`login?client=${e.target.value}`);
    } else {
      this.theme.removeClient();
      this.selectedPartner = this.theme.getClientName;
      window.location.replace('login');
    }
    this.selectedPartnerLogo = `https://img.travelx.ai/partner/${e.target.value}.png`;
  }

  initializeApp() {
    const userAgent = this.platform.is('ios')
      ? 'ios'
      : this.platform.is('android')
      ? 'android'
      : 'browser';
    const scope = Sentry.getCurrentScope();
    scope.setTag('user_agent', userAgent);
    // Decide language on initial load
    const selectedLanguage = this.localStorageData.getItem(
      localStorageKeys.LANGUAGE
    );
    if (selectedLanguage && typeof selectedLanguage !== 'undefined') {
      this.i18Config.setDefaultLanguage(selectedLanguage);
    } else {
      this.i18Config.setDefaultLanguage(this.i18Config.getDefaultLanguage());
    }

    this.platform.ready().then(async () => {
      this.platform.backButton.subscribe(() => {
        if (this.document.body.classList.contains('scanner-active')) {
          this.barcodeScannerService.stopBarcodeScan();
        }
      });

      if (Capacitor.getPlatform() !== 'web') {
        await this.locationService.checkForLocationAccess();
      }

      this.pushNotificationService.addListners();
      // eslint-disable-next-line max-len
      //? doing this here in addition to homepage as we need to check for notifcation permission if the homepage is not default page which is possible for some clients
      if (this.accountService.isLoggedIn() && !this.accountService.deviceID) {
        // this.pushNotificationService.initPush();
      }
      this.pushNotificationService.clearBadge();
    });

    // close all popovers on back navigation, if open.
    this.router.events.subscribe((event: any): void => {
      this.hasError = false;
      if (event instanceof NavigationEnd) {
        // Safety: ensure no global loader lingers after navigation completes,
        // Always clear loaders on any route including /redirecting
        this.uiService.dismissGlobalLoading();

        // Emit a single canonical page_view on stable navigation. We used to
        // emit on NavigationStart, which read the route snapshot before it had
        // settled — that caused mismatched payloads (url=blank, page_name=next
        // page or vice versa). NavigationEnd guarantees URL + routeData agree.
        let currentRoute = this.route.root;
        while (currentRoute.firstChild) {
          currentRoute = currentRoute.firstChild;
        }
        const routeData = currentRoute.snapshot.data;
        const pageTitle = this.formatTitleByUrlParams(
          routeData?.title || '',
          event.urlAfterRedirects || event.url
        );
        const settledUrl = event.urlAfterRedirects || event.url;
        const cleanPath = this.analyticsService.getCleanPathFromUrl(settledUrl);
        const measurementId = this.analyticsService.googleAnalyticsId;
        const globalGtag =
          typeof window !== 'undefined' && typeof window['gtag'] === 'function'
            ? window['gtag']
            : undefined;
        if (measurementId && globalGtag) {
          globalGtag('config', measurementId, {
            page_path: cleanPath,
            page_title: pageTitle,
            send_page_view: false,
          });
        }
        // trackPageView itself skips transient routes (/blank, /redirecting)
        // and dedups within a short window — safe to always call.
        this.analyticsService.trackPageView(pageTitle, {
          url: settledUrl,
          referrer: document.referrer,
          timestamp: new Date().toISOString(),
        });
      }

      if (event instanceof NavigationStart) {
        this.status = this.connected ? 'ONLINE' : 'OFFLINE';
        // Also clear any orphan loaders before starting a new navigation
        this.uiService.dismissGlobalLoading();
        if (event.navigationTrigger === 'popstate') {
          this.autocloseOverlaysService.trigger();
        }
      }
    });

    //if there is any HTTP error
    /**TODO: this is not working, as expected, Ex. I have a API running in the background
     * for mobileregistration out of nowhere it showed me try again screen, I dont care if that API is successfull or not
     * need to find a better way to handle this
     */
    // this.broadCastService.http404.asObservable().subscribe((values) => {
    //   this.hasError = values;
    // });

    // trigger update notification on new build release.
    this.swUpdates.versionUpdates
      .pipe(
        filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'),
        map((evt) => ({
          type: 'UPDATE_AVAILABLE',
          current: evt.currentVersion,
          available: evt.latestVersion,
        }))
      )
      .subscribe((event) => {
        this.uiService.showUpdateToast();
      });

    // for recognizing internet connection
    this.connectionService.monitor().subscribe((connectionState) => {
      if (!connectionState.hasNetworkConnection) {
        this.internetToast.present();
      } else {
        if (this.internetToast) {
          this.internetToast.dismiss();
        }
        this.initInternetToast(); // reinstatiating toast here to be ready to present after loss of internet
      }
      this.connected = connectionState.hasNetworkConnection;
    });

    this.initInternetToast();
    this.apiErrorService.value.subscribe((val) => {
      if (!this.isInitialLoading) {
        this.hasError = val;
      }
    });
    if (Capacitor.getPlatform() !== 'web') {
      this.locationService.checkForLocationAccess();
    }

    App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      this.zone.run(() => {
        try {
          const slug = event.url.split('.app').pop();
          const urlObject = new URL(slug, window.location.origin);
          const pagePath = decodeURIComponent(urlObject.pathname);
          const searchParam = urlObject.search;
          if (pagePath && searchParam) {
            this.navController.navigateRoot(pagePath + searchParam);
          } else if (pagePath) {
            this.navController.navigateRoot(pagePath);
          }
        } catch (error) {
          console.error('Failed to parse deep link URL:', error);
        }
      });
    });
  }

  private formatTitleByUrlParams(title: string, url: string): string {
    const urlObj = new URL(url, window.location.origin);
    const params: { [key: string]: string } = {};
    urlObj.searchParams.forEach((value, key) => {
      params[key] = value;
    });
    const urlWithoutParams = urlObj.pathname;

    const path = urlWithoutParams.split(';')[0];

    if (path === '/bajaj' || path === '/bajaj/travel') {
      if (params['type'] === 'flights') return 'Flight Search Page';
      if (params['type'] === 'hotels') return 'Hotel Search Page';
      if (params['type'] === 'flexicancel')
        return 'FlexiCancel Search Page';
      if (params['type'] === 'bus') return 'Bus Search Page';
      return 'Home Page';
    }

    if (path === '/booking-history' || path === '/bajaj/booking-history') {
      if (params['tab'] === 'flight-booking') return 'Booking History Flight Page';
      if (params['tab'] === 'hotel-booking') return 'Booking History Hotel Page';
      if (params['tab'] === 'bus-booking') return 'Booking History Bus Page';
      if (params['tab'] === 'esim-booking') return 'Booking History Esim Page';
      if (params['tab'] === 'lounge-booking') return 'Booking History Lounge Page';
      return 'Booking History Page';
    }

    if (title) return title;

    const slug = path.replace(/^\/|\/$/g, '');
    if (!slug) return 'Home Page';
    return slug
      .replace(/\/[0-9a-f]{8,}(?:-[0-9a-f]{4,}){0,4}/gi, '')
      .replace(/\/\d+/g, '')
      .replace(/\//g, ' ')
      .replace(/-/g, ' ')
      .replace(/\b\w/g, (l) => l.toUpperCase())
      .trim() + ' Page';
  }

  initInternetToast() {
    this.translate.get('APP.internet').subscribe((translatedText) => {
      this.toastController
        .create({
          header: translatedText,
          position: 'top',
          translucent: true,
          buttons: [],
        })
        .then((response) => {
          this.internetToast = response;
        });
    });
  }
}
